/* eslint-disable no-undef */
window.theme = window.theme || {};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

( function ( $ ) {
  var $ = jQuery = $;

  theme.utils = {
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function ( value, defaultValue ) {
      return ( value == null || value !== value ) ? defaultValue : value
    }
  };

  theme.a11y = {

    /**
     * Traps the focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    trapFocus: function ( options ) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if ( !options.$elementToFocus ) {
        options.$elementToFocus = options.$container;
      }

      options.$container.attr( 'tabindex', '-1' );
      options.$elementToFocus.focus();

      $( document ).off( 'focusin' );

      $( document ).on( eventName, function ( evt ) {
        if ( options.$container[ 0 ] !== evt.target && !options.$container.has( evt.target ).length ) {
          options.$container.focus();
        }
      } );
    },

    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function ( options ) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if ( options.$container && options.$container.length ) {
        options.$container.removeAttr( 'tabindex' );
      }

      $( document ).off( eventName );
    },


    // Not from Slate, but fit in the a11y category
    lockMobileScrolling: function ( namespace, $element ) {
      if ( $element ) {
        var $el = $element;
      } else {
        var $el = $( document.documentElement ).add( 'body' );
      }
      $el.on( 'touchmove' + namespace, function () {
        return false;
      } );
    },

    unlockMobileScrolling: function ( namespace, $element ) {
      if ( $element ) {
        var $el = $element;
      } else {
        var $el = $( document.documentElement ).add( 'body' );
      }
      $el.off( namespace );
    }
  };

  theme.Sections = function Sections () {
    this.constructors = {};
    this.instances = [];

    $( document )
      .on( 'shopify:section:load', this._onSectionLoad.bind( this ) )
      .on( 'shopify:section:unload', this._onSectionUnload.bind( this ) )
      .on( 'shopify:section:select', this._onSelect.bind( this ) )
      .on( 'shopify:section:deselect', this._onDeselect.bind( this ) )
      .on( 'shopify:block:select', this._onBlockSelect.bind( this ) )
      .on( 'shopify:block:deselect', this._onBlockDeselect.bind( this ) );
  };

  theme.Sections.prototype = $.extend( {}, theme.Sections.prototype, {
    createInstance: function ( container, constructor, customScope ) {
      var $container = $( container );
      var id = $container.attr( 'data-section-id' );
      var type = $container.attr( 'data-section-type' );

      constructor = constructor || this.constructors[ type ];

      if ( typeof constructor === 'undefined' ) {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if ( customScope ) {
        var instanceExists = this._findInstance( id );
        if ( instanceExists ) {
          return;
        }
      }

      var instance = $.extend( new constructor( container ), {
        id: id,
        type: type,
        container: container
      } );

      this.instances.push( instance );
    },

    _onSectionLoad: function ( evt, subSection, subSectionId ) {


      var container = subSection ? subSection : $( '[data-section-id]', evt.target )[ 0 ];

      if ( !container ) {
        return;
      }

      this.createInstance( container );

      var instance = subSection ? subSectionId : this._findInstance( evt.detail.sectionId );

      if ( !subSection ) {
        this._loadSubSections();
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if ( instance && typeof instance.onLoad === 'function' ) {
        instance.onLoad( evt );
      }
    },

    _loadSubSections: function () {


      $( '[data-subsection]' ).each( function ( evt, el ) {
        this._onSectionLoad( null, el, $( el ).data( 'section-id' ) );
      }.bind( this ) );
    },

    _onSectionUnload: function ( evt ) {
      var instance = this._removeInstance( evt.detail.sectionId );
      if ( instance && typeof instance.onUnload === 'function' ) {
        instance.onUnload( evt );
      }
    },

    _onSelect: function ( evt ) {
      var instance = this._findInstance( evt.detail.sectionId );

      if ( instance && typeof instance.onSelect === 'function' ) {
        instance.onSelect( evt );
      }
    },

    _onDeselect: function ( evt ) {
      var instance = this._findInstance( evt.detail.sectionId );

      if ( instance && typeof instance.onDeselect === 'function' ) {
        instance.onDeselect( evt );
      }
    },

    _onBlockSelect: function ( evt ) {
      var instance = this._findInstance( evt.detail.sectionId );

      if ( instance && typeof instance.onBlockSelect === 'function' ) {
        instance.onBlockSelect( evt );
      }
    },

    _onBlockDeselect: function ( evt ) {
      var instance = this._findInstance( evt.detail.sectionId );

      if ( instance && typeof instance.onBlockDeselect === 'function' ) {
        instance.onBlockDeselect( evt );
      }
    },

    _findInstance: function ( id ) {
      for ( var i = 0; i < this.instances.length; i++ ) {
        if ( this.instances[ i ].id === id ) {
          return this.instances[ i ];
        }
      }
    },

    _removeInstance: function ( id ) {
      var i = this.instances.length;
      var instance;

      while ( i-- ) {
        if ( this.instances[ i ].id === id ) {
          instance = this.instances[ i ];
          this.instances.splice( i, 1 );
          break;
        }
      }

      return instance;
    },

    register: function ( type, constructor, $scope ) {
      var afterLoad = false;
      this.constructors[ type ] = constructor;
      var $sections = $( '[data-section-type=' + type + ']' );

      if ( $scope ) {
        $sections = $( '[data-section-type=' + type + ']', $scope );
      }

      $sections.each( function ( index, container ) {
        this.createInstance( container, constructor, $scope );
      }.bind( this ) );
    }
  } );


  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */

  theme.Currency = ( function () {
    var moneyFormat = '${{amount}}';

    function formatMoney ( cents, format ) {
      if ( !format ) {
        format = theme.settings.moneyFormat;
      }
      if ( typeof cents === 'string' ) {
        cents = cents.replace( '.', '' );
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = ( format || moneyFormat );

      function formatWithDelimiters ( number, precision, thousands, decimal ) {
        precision = theme.utils.defaultTo( precision, 2 );
        thousands = theme.utils.defaultTo( thousands, ',' );
        decimal = theme.utils.defaultTo( decimal, '.' );

        if ( isNaN( number ) || number == null ) {
          return 0;
        }

        number = ( number / 100.0 ).toFixed( precision );

        var parts = number.split( '.' );
        var dollarsAmount = parts[ 0 ].replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands );
        var centsAmount = parts[ 1 ] ? ( decimal + parts[ 1 ] ) : '';

        return dollarsAmount + centsAmount;
      }

      switch ( formatString.match( placeholderRegex )[ 1 ] ) {
        case 'amount':
          value = formatWithDelimiters( cents, 2 );
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters( cents, 0 );
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters( cents, 2, '.', ',' );
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters( cents, 0, '.', ',' );
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters( cents, 0, ' ' );
          break;
      }

      return formatString.replace( placeholderRegex, value );
    }

    function getBaseUnit ( variant ) {
      if ( !variant ) {
        return;
      }

      if ( !variant.unit_price_measurement || !variant.unit_price_measurement.reference_value ) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  } )();


  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */

  theme.Images = ( function () {

    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize ( src ) {
      if ( !src ) {
        return '620x'; // default based on theme
      }

      var match = src.match( /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/ );

      if ( match !== null ) {
        return match[ 1 ];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl ( src, size ) {
      if ( !src ) {
        return src;
      }

      if ( size == null ) {
        return src;
      }

      if ( size === 'master' ) {
        return this.removeProtocol( src );
      }

      var match = src.match( /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i );

      if ( match != null ) {
        var prefix = src.split( match[ 0 ] );
        var suffix = match[ 0 ];

        return this.removeProtocol( prefix[ 0 ] + '_' + size + suffix );
      }

      return null;
    }

    function removeProtocol ( path ) {
      return path.replace( /http(s)?:/, '' );
    }

    /**
     * Create lazyloading-friendly image string
     *
     * @param string
     * @returns string with _{width}x as size param
     */
    function lazyloadImagePath ( string ) {
      var image;

      if ( string !== null ) {
        image = string.replace( /(\.[^.]*)$/, "_{width}x$1" );
      }

      return image;
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  } )();

  theme.Variants = ( function () {

    function Variants ( options ) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();

      $( this.singleOptionSelector, this.$container ).on( 'change', this._onSelectChange.bind( this ) );
    }

    Variants.prototype = $.extend( {}, Variants.prototype, {

      _getCurrentOptions: function () {
        var currentOptions = $.map( $( this.singleOptionSelector, this.$container ), function ( element ) {
          var $element = $( element );
          var type = $element.attr( 'type' );
          var currentOption = {};

          if ( type === 'radio' || type === 'checkbox' ) {
            if ( $element[ 0 ].checked ) {
              currentOption.value = $element.val();
              currentOption.index = $element.data( 'index' );

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data( 'index' );

            return currentOption;
          }
        } );

        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact( currentOptions );

        return currentOptions;
      },

      _getVariantFromOptions: function () {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;

        variants.forEach( function ( variant, i ) {
          var match = true;
          var options = variant.options;

          selectedValues.forEach( function ( option ) {
            if ( match ) {
              match = ( variant[ option.index ] === option.value );
            }
          } );

          if ( match ) {
            found = variant;
            variant.index = i;
          }
        } );

        return found || null;
      },

      _onSelectChange: function () {
        var variant = this._getVariantFromOptions();

        this.$container.trigger( {
          type: 'variantChange',
          variant: variant
        } );

        if ( !variant ) {
          if ( window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function' ) {
            BOLD.common.eventEmitter.emit( 'BOLD_COMMON_variant_changed' );
          }
          return;
        }


        this._updateMasterSelect( variant );
        this._updateImages( variant );
        this._updatePrice( variant );
        this._updateUnitPrice( variant );
        this._updateSKU( variant );
        // Custom code: variant badges
        this._updateVariantBadges( variant );
        this._updateVariantTitle( variant );
        this.currentVariant = variant;

        if ( this.enableHistoryState ) {
          this._updateHistoryState( variant );
        }


        if ( window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function' ) {
          BOLD.common.eventEmitter.emit( 'BOLD_COMMON_variant_changed' );
        }
      },

      // Custom code: variant badges
      _updateVariantBadges: function ( variant ) {
        try {
          const badge = document.querySelector( ".product__variant-image-badge" )
          if ( !badge ) return

          var variantImage = variant.featured_image || {};
          var currentVariantImage = this.currentVariant.featured_image || {};

          const data = JSON.parse( document.querySelector( "#VariantBadgesData" )?.innerText || "{}" )
          const text = ( data[ variant?.id ]?.[ 0 ] || "" ).trim()

          if ( !text ) {
            badge.classList.add( "hide" )
            badge.innerText = ""
          } else {
            badge.classList.remove( "hide" )
            badge.innerText = text
          }

        } catch ( error ) {
          console.error( error )
        }

        // if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        //   return;
        // }

        // this.$container.trigger({
        //   type: 'variantImageChange',
        //   variant: variant
        // });
      },

      _updateImages: function ( variant ) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if ( !variant.featured_image || variantImage.src === currentVariantImage.src ) {
          return;
        }

        this.$container.trigger( {
          type: 'variantImageChange',
          variant: variant
        } );
      },

      _updatePrice: function ( variant ) {
        if ( variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price ) {
          return;
        }

        this.$container.trigger( {
          type: 'variantPriceChange',
          variant: variant
        } );
      },

      _updateUnitPrice: function ( variant ) {
        if ( variant.unit_price === this.currentVariant.unit_price ) {
          return;
        }

        this.$container.trigger( {
          type: 'variantUnitPriceChange',
          variant: variant
        } );
      },

      _updateSKU: function ( variant ) {
        if ( variant.sku === this.currentVariant.sku ) {
          return;
        }

        this.$container.trigger( {
          type: 'variantSKUChange',
          variant: variant
        } );
      },

      _updateVariantTitle: function ( variant ) {
        if ( variant.variantTitle === this.currentVariant.title ) {
          return;
        }

        this.$container.trigger( {
          type: 'variantTitleChange',
          variant: variant
        } );
      },

      _updateHistoryState: function ( variant ) {
        if ( !history.replaceState || !variant ) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState( { path: newurl }, '', newurl );
      },

      _updateMasterSelect: function ( variant ) {
        $( this.originalSelectorId, this.$container ).val( variant.id );
      },

      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function ( array ) {
        var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

        while ( ++index < length ) {
          var value = array[ index ];
          if ( value ) {
            result[ resIndex++ ] = value;
          }
        }
        return result;
      }
    } );

    return Variants;
  } )();


  theme.cart = {
    getCart: function () {
      return $.getJSON( '/cart.js' );
    },

    changeItem: function ( key, qty ) {
      return this._updateCart( {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      } );
    },

    addItemFromForm: function ( data ) {
      return this._updateCart( {
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      } );
    },

    _updateCart: function ( params ) {
      return $.ajax( params )
        .then( function ( cart ) {
          return cart;
        }.bind( this ) )
    },

    updateNote: function ( note ) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString( note ),
        dataType: 'json',
        success: function ( cart ) { },
        error: function ( XMLHttpRequest, textStatus ) { }
      };

      $.ajax( params );
    },

    updateCurrency: function ( code ) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'currency=' + code,
        dataType: 'json',
        success: function ( cart ) {
          location.reload(); // required for multi-currency feature to update
        },
        error: function ( XMLHttpRequest, textStatus ) { }
      };

      $.ajax( params );
    },

    attributeToString: function ( attribute ) {
      if ( ( typeof attribute ) !== 'string' ) {
        attribute += '';
        if ( attribute === 'undefined' ) {
          attribute = '';
        }
      }
      return $.trim( attribute );
    }
  }

  $( function () {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $( 'body' ).on( 'click', '.cart__checkout', function () {
      $( this ).addClass( 'btn--loading' );
    } );

    $( 'body' ).on( 'change', 'textarea[name="note"]', function () {
      var newNote = $( this ).val();
      theme.cart.updateNote( newNote );
    } );


    // Custom JS to prevent checkout without confirming terms and conditions
    $( 'body' ).on( 'click', '.cart__checkout--ajax', function ( evt ) {
      if ( $( '#CartAgree' ).is( ':checked' ) ) {
      } else {
        alert( theme.strings.cartTermsConfirmation );
        $( this ).removeClass( 'btn--loading' );
        return false;
      }
    } );

    $( 'body' ).on( 'click', '.cart__checkout--page', function ( evt ) {
      if ( $( '#CartPageAgree' ).is( ':checked' ) ) {
      } else {
        alert( theme.strings.cartTermsConfirmation );
        $( this ).removeClass( 'btn--loading' );
        return false;
      }
    } );
  } );

  theme.QtySelector = ( function () {
    var classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector ( $el, options ) {
      this.$wrapper = $el;
      this.$input = $el.find( classes.input );
      this.$plus = $el.find( classes.plus );
      this.$minus = $el.find( classes.minus );
      this.minValue = this.$input.attr( 'min' ) || 1;

      var defaults = {
        namespace: null,
        key: this.$input.data( 'id' )
      };

      this.options = $.extend( defaults, options );

      this.initEventListeners();
    };

    QtySelector.prototype = $.extend( {}, QtySelector.prototype, {
      initEventListeners: function () {
        this.$plus.on( 'click', function () {
          var qty = this.validateQty( this.$input.val() );
          this.addQty( qty );
        }.bind( this ) );

        this.$minus.on( 'click', function () {
          var qty = this.validateQty( this.$input.val() );
          this.subtractQty( qty );
        }.bind( this ) );

        this.$input.on( 'change', function () {
          var qty = this.validateQty( this.$input.val() );
          this.changeQty( qty );
        }.bind( this ) );
      },

      addQty: function ( number ) {
        var qty = number + 1;
        this.changeQty( qty );
      },

      subtractQty: function ( number ) {
        var qty = number - 1;
        if ( qty <= this.minValue ) {
          qty = this.minValue;
        }
        this.changeQty( qty );
      },

      changeQty: function ( qty ) {
        this.$input.val( qty );
        $( 'body' ).trigger( 'qty' + this.options.namespace, [ this.options.key, qty ] );
      },

      validateQty: function ( number ) {
        if ( ( parseFloat( number ) == parseInt( number ) ) && !isNaN( number ) ) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          number = 1;
        }
        return parseInt( number );
      }
    } );

    return QtySelector;
  } )();






  theme.customerTemplates = ( function () {

    function initEventListeners () {
      // Show reset password form
      $( '#RecoverPassword' ).on( 'click', function ( evt ) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      } );

      // Hide reset password form
      $( '#HideRecoverPasswordLink' ).on( 'click', function ( evt ) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      } );
    }

    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm () {
      $( '#RecoverPasswordForm' ).toggleClass( 'hide' );
      $( '#CustomerLoginForm' ).toggleClass( 'hide' );
    }

    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess () {
      var $formState = $( '.reset-password-success' );

      // check if reset password form was successfully submitted
      if ( !$formState.length ) {
        return;
      }

      // show success message
      $( '#ResetSuccess' ).removeClass( 'hide' );
    }

    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm () {
      var $newAddressForm = $( '#AddressNewForm' );
      var $addressForms = $( '.js-address-form' );

      if ( !$newAddressForm.length || !$addressForms.length ) {
        return;
      }

      if ( Shopify ) {
        $( '.js-address-country' ).each( function () {
          var $container = $( this );
          var countryId = $container.data( 'country-id' );
          var provinceId = $container.data( 'province-id' );
          var provinceContainerId = $container.data( 'province-container-id' );

          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        } );
      }

      // Toggle new/edit address forms
      $( '.address-new-toggle' ).on( 'click', function () {
        $newAddressForm.toggleClass( 'hide' );
      } );

      $( '.address-edit-toggle' ).on( 'click', function () {
        var formId = $( this ).data( 'form-id' );
        $( '#EditAddress_' + formId ).toggleClass( 'hide' );
      } );

      $( '.address-delete' ).on( 'click', function () {
        var $el = $( this );
        var formId = $el.data( 'form-id' );
        var confirmMessage = $el.data( 'confirm-message' );

        if ( confirm( confirmMessage || 'Are you sure you wish to delete this address?' ) ) {
          Shopify.postLink( '/account/addresses/' + formId, { parameters: { _method: 'delete' } } );
        }
      } );
    }

    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash () {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if ( hash === '#recover' ) {
        toggleRecoverPasswordForm();
      }
    }

    return {
      init: function () {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  } )();


  theme.Product = ( function () {

    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };

    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current'
    };

    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onVideoPlayerReady,
        onStateChange: onVideoStateChange
      }
    };

    var vimeoReady;
    var vimeoPlayers = [];
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };

    function onVideoPlayerReady ( evt ) {
      /*
      var $player = evt.target.a ? $(evt.target.a) : $(evt.target.f);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute().playVideo().pauseVideo();
      } else {
        setParentAsLoaded($player);
      }
  
      // If first slide or only photo, start video
      if ($player.closest(selectors.currentSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
      */
    }

    function initCheckVisibility ( playerId ) {
      // Add out of view pausing
      videoVisibilityCheck( playerId );
      $( window ).on( 'scroll.' + playerId, { id: playerId }, $.throttle( 150, videoVisibilityCheck ) );
    }

    function videoVisibilityCheck ( id ) {
      /*
        var playerId;
    
        if (typeof id === 'string') {
          playerId = id;
        } else {
          // Data comes in as part of the scroll event
          playerId = id.data.id;
        }
    
        if (theme.isElementVisible($('#' + playerId))) {
          if (videos[playerId] && videos[playerId].style === 'unmuted') {
            return;
          }
          playVisibleVideo(playerId);
        } else {
          pauseHiddenVideo(playerId);
        }
        */
    }

    function playVisibleVideo ( id ) {
      /*
     if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
       youtubePlayers[id].playVideo();
     }
     */
    }

    function pauseHiddenVideo ( id ) {
      /*
     if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
       youtubePlayers[id].pauseVideo();
     }
     */
    }

    function onVideoStateChange ( evt ) {
      /*
     var $player = evt.target.a ? $(evt.target.a) : $(evt.target.f);
     var playerId = $player.attr('id');
     var player = youtubePlayers[playerId];
 
     switch (evt.data) {
       case -1: // unstarted
         // Handle low power state on iOS by checking if
         // video is reset to unplayed after attempting to buffer
         if (videos[playerId].attemptedToPlay) {
           setParentAsLoaded($player);
           setVideoToBeInteractedWith($player);
         }
         break;
       case 0: // ended
         player.playVideo();
         break;
       case 1: // playing
         setParentAsLoaded($player);
         break;
       case 3: // buffering
         videos[playerId].attemptedToPlay = true;
         break;
     }
     */
    }

    function setParentAsLoading ( $el ) {
      $el
        .closest( selectors.videoParent )
        .addClass( classes.loading );
    }

    function setParentAsLoaded ( $el ) {
      $el
        .closest( selectors.videoParent )
        .removeClass( classes.loading )
        .addClass( classes.loaded );
    }



    function Product ( container ) {
      var $container = this.$container = $( container );
      var sectionId = this.sectionId = $container.attr( 'data-section-id' );


      this.settings = {
        enableHistoryState: $container.data( 'enable-history-state' ) || false,
        namespace: '.product-' + sectionId,
        inventory: $container.data( 'inventory' ) || false,
        incomingInventory: $container.data( 'incoming-inventory' ) || false,
        modalInit: false,
        lazyLoadModalContent: $container.data( 'lazyload-content' ) || false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        thumbArrows: false,
        thumbVertical: false,
        hasImages: true,
        hasMultipleImages: false,
        imageSize: '620x'
      };



      this.selectors = {
        variantsJson: 'VariantsJson-' + sectionId,
        currentVariantJson: 'CurrentVariantJson-' + sectionId,
        initialVariantJson: 'InitialVariantJson-' + sectionId,

        video: 'ProductVideo-' + sectionId,
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        mainSlider: '#ProductPhotos-' + sectionId,
        imageContainer: '[data-product-images]',
        productImageMain: '.product-image-main--' + sectionId,

        priceWrapper: '.js-product-prices' + sectionId,
        price: '.js-price-default-' + sectionId,
        comparePrice: '.js-price-old-' + sectionId,
        savePrice: '#SavePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        unitWrapper: '.product__unit-price-wrapper--' + sectionId,
        unitPrice: '.product__unit-price--' + sectionId,
        unitPriceBaseUnit: '.product__unit-base--' + sectionId,
        sku: '#Sku-' + sectionId,
        variantTitle: '.js-product-variant-' + sectionId,
        inventory: '#ProductInventory-' + sectionId,
        incomingInventory: '#ProductIncomingInventory-' + sectionId,

        addToCart: '.js-product-buy-' + sectionId,
        addToCartText: '.js-product-buy-text-' + sectionId,

        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,

        modalFormHolder: '#ProductFormHolder-' + sectionId,
        formContainer: '#AddToCartForm-' + sectionId
      };



      this.$mainSlider = $( this.selectors.mainSlider );
      this.$thumbSlider = $( this.selectors.thumbSlider );

      // Init filter here
      // ttt
      this.$container.on( 'variantChange' + this.settings.namespace, function ( evt ) {
        const filterClass = `.lifestyle-img,.variant-img-${ evt.variant.index }`
        this.updateSliderFilters( filterClass )
      }.bind( this ) )


      this.$firstProductImage = this.$mainSlider.find( 'img' ).first();

      if ( !this.$firstProductImage.length ) {
        this.settings.hasImages = false;
      }

      this.init();



    }

    Product.prototype = $.extend( {}, Product.prototype, {
      init: function () {
        if ( this.inModal ) {
          this.$container.addClass( classes.isModal );
          $( 'body' )
            .off( 'modalOpen.QuickShopModal-' + this.sectionId )
            .off( 'modalClose.QuickShopModal-' + this.sectionId );
          $( 'body' ).on( 'modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind( this ) );
          $( 'body' ).on( 'modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind( this ) );
        }

        if ( !this.inModal ) {
          this.stringOverrides();
          this.formSetup();
          this.productSetup();



          this.createImageCarousels();
          if ( $( '#LensCategory-' + this.sectionId + '-gallery' ).length ) {
            this.setProductType( $( '.js-main-product-selectbox option:selected' ).attr( 'data-variant-title' ) )
          }



        }


      },



      formSetup: function () {
        // Determine how to handle variant availability selectors
        if ( theme.settings.dynamicVariantsEnable ) {
          this.$variantSelectors = $( this.selectors.formContainer ).find( this.selectors.singleOptionSelector );
        }

        this.initQtySelector();
        //this.initAjaxProductForm();
        this.initVariants();
      },

      productSetup: function () {
        // this.setImageSizes();
        // this.initImageSwitch();
        //  this.initImageZoom();
      },

      addIdToRecentlyViewed: function () {
        /*
        var handle = this.$container.attr('data-product-handle');
        var url = this.$container.attr('data-product-url');
        var aspectRatio = this.$container.attr('data-aspect-ratio');
        var featuredImage = this.$container.attr('data-img-url');
  
        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
  
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };
  
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
        */
      },

      initImageZoom: function () {
        //var $container = $(this.selectors.imageContainer, this.$container);
        //var imageZoom = new theme.Photoswipe($container[0], this.sectionId);
      },

      stringOverrides: function () {
        theme.productStrings = theme.productStrings || {};
        $.extend( theme.strings, theme.productStrings );
      },

      setImageSizes: function () {
        if ( !this.settings.hasImages ) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[ 0 ].currentSrc;

        if ( currentImage ) {
          this.settings.imageSize = theme.Images.imageSize( currentImage );
        }
      },

      initVariants: function () {



        if ( !document.getElementById( this.selectors.variantsJson ) ) {

          if ( window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function' ) {
            BOLD.common.eventEmitter.emit( 'BOLD_COMMON_variant_changed' );
          }
          return;
        }

        this.variantsObject = JSON.parse( document.getElementById( this.selectors.variantsJson ).innerHTML );




        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };

        if ( $( this.selectors.variantColorSwatch ).length ) {
          $( this.selectors.variantColorSwatch ).on( 'change', function ( evt ) {
            var $el = $( evt.currentTarget );
            var color = $el.data( 'color-name' );
            var index = $el.data( 'color-index' );
            this.updateColorName( color, index );


          }.bind( this ) );
        }

        this.variants = new theme.Variants( options );

        this.$container
          .on( 'variantChange' + this.settings.namespace, this.updateCartButton.bind( this ) )
          .on( 'variantChange' + this.settings.namespace, this.updateVariantButtonAvailability.bind( this ) )
          .on( 'variantImageChange' + this.settings.namespace, this.updateVariantImage.bind( this ) )
          .on( 'variantPriceChange' + this.settings.namespace, this.updatePrice.bind( this ) )
          .on( 'variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind( this ) );

        if ( $( this.selectors.sku ).length ) {
          this.$container.on( 'variantSKUChange' + this.settings.namespace, this.updateSku.bind( this ) );
        }
        if ( $( this.selectors.variantTitle ).length ) {

          this.$container.on( 'variantTitleChange' + this.settings.namespace, this.updateVariantTitle.bind( this ) );

        }
        if ( this.settings.inventory || this.settings.incomingInventory ) {
          this.$container.on( 'variantChange' + this.settings.namespace, this.updateInventory.bind( this ) );
        }

        // Update individual variant availability on each selection
        if ( theme.settings.dynamicVariantsEnable && document.getElementById( this.selectors.currentVariantJson ) ) {
          this.currentVariantObject = JSON.parse( document.getElementById( this.selectors.currentVariantJson ).innerHTML );

          this.$variantSelectors.on( 'change' + this.settings.namespace, this.updateVariantAvailability.bind( this ) );

          // Set default state based on current selected variant
          this.setCurrentVariantAvailability( this.currentVariantObject, true );
        }

        if ( window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function' ) {
          BOLD.common.eventEmitter.emit( 'BOLD_COMMON_variant_changed' );
        }
      },

      setCurrentVariantAvailability: function ( variant ) {
        var valuesToEnable = {
          option1: [],
          option2: [],
          option3: []
        };

        // Disable all options to start
        this.disableVariantGroup( $( this.selectors.formContainer ).find( '.variant-input-wrap' ) );

        // Combine all available variants
        var availableVariants = this.variantsObject.filter( function ( el ) {
          if ( variant.id === el.id ) {
            return false;
          }

          // Option 1
          if ( variant.option2 === el.option2 && variant.option3 === el.option3 ) {
            return true;
          }

          // Option 2
          if ( variant.option1 === el.option1 && variant.option3 === el.option3 ) {
            return true;
          }

          // Option 3
          if ( variant.option1 === el.option1 && variant.option2 === el.option2 ) {
            return true;
          }
        } );


        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
          variant: variant
        };

        availableVariants = Object.assign( {}, variantObject, availableVariants );

        // Loop through each available variant to gather variant values
        for ( var property in availableVariants ) {
          if ( availableVariants.hasOwnProperty( property ) ) {
            var item = availableVariants[ property ];
            var option1 = item.option1;
            var option2 = item.option2;
            var option3 = item.option3;

            if ( option1 ) {
              if ( valuesToEnable.option1.indexOf( option1 ) === -1 ) {
                valuesToEnable.option1.push( option1 );
              }
            }
            if ( option2 ) {
              if ( valuesToEnable.option2.indexOf( option2 ) === -1 ) {
                valuesToEnable.option2.push( option2 );
              }
            }
            if ( option3 ) {
              if ( valuesToEnable.option3.indexOf( option3 ) === -1 ) {
                valuesToEnable.option3.push( option3 );
              }
            }
          }
        }

        // Have values to enable, separated by option index
        if ( valuesToEnable.option1.length ) {
          this.enableVariantOptionByValue( valuesToEnable.option1, 'option1' );
        }
        if ( valuesToEnable.option2.length ) {
          this.enableVariantOptionByValue( valuesToEnable.option2, 'option2' );
        }
        if ( valuesToEnable.option3.length ) {
          this.enableVariantOptionByValue( valuesToEnable.option3, 'option3' );
        }
      },

      updateVariantAvailability: function ( evt, value, index ) {
        if ( value && index ) {
          var newVal = value;
          var optionIndex = index;
        } else {
          var $el = $( evt.currentTarget );
          var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
          var optionIndex = $el.data( 'index' );
        }

        var variants = this.variantsObject.filter( function ( el ) {
          return el[ optionIndex ] === newVal;
        } );

        // Disable all buttons/dropdown options that aren't the current index
        $( this.selectors.formContainer ).find( '.variant-input-wrap' ).each( function ( index, el ) {
          var $group = $( el );
          var currentOptionIndex = $group.data( 'index' );

          if ( currentOptionIndex !== optionIndex ) {
            // Disable all options as a starting point
            this.disableVariantGroup( $group );

            // Loop through legit available options and enable
            for ( var i = 0; i < variants.length; i++ ) {
              this.enableVariantOption( $group, variants[ i ][ currentOptionIndex ] );
            }
          }
        }.bind( this ) );
      },

      disableVariantGroup: function ( $group ) {
        if ( theme.settings.dynamicVariantType === 'dropdown' ) {
          $group.find( 'option' ).prop( 'disabled', true )
        } else {
          $group.find( 'input' ).prop( 'disabled', true );
          $group.find( 'label' ).toggleClass( 'disabled', true );
        }
      },

      enableVariantOptionByValue: function ( array, index ) {
        var $group = $( this.selectors.formContainer ).find( '.variant-input-wrap[data-index="' + index + '"]' );

        for ( var i = 0; i < array.length; i++ ) {
          this.enableVariantOption( $group, array[ i ] );
        }
      },

      enableVariantOption: function ( $group, value ) {
        // Selecting by value so escape it
        value = value.replace( /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1' );

        if ( theme.settings.dynamicVariantType === 'dropdown' ) {
          $group.find( 'option[value="' + value + '"]' ).prop( 'disabled', false );
        } else {
          var $buttonGroup = $group.find( '.variant-input[data-value="' + value + '"]' );
          $buttonGroup.find( 'input' ).prop( 'disabled', false );
          $buttonGroup.find( 'label' ).toggleClass( 'disabled', false );
        }
      },

      // Variant change functions
      updateColorName: function ( color, index ) {
        // Updates on radio button change, not variant.js
        $( '#VariantColorLabel-' + this.sectionId + '-' + index ).text( color );
      },

      updateCartButton: function ( evt ) {
        var variant = evt.variant;

        const form = this.selectors.formContainer && document.querySelector(this.selectors.formContainer)

        if ( variant ) {
          if (form) form.dataset.selectedVariant = variant.id
          if ( variant.available ) {
            // Available, enable the submit button and change text
            $( '.js-status-avl' ).removeClass( 'hide' );
            $( '.js-status-soldout' ).addClass( 'hide' );
          } else {
            $( '.js-status-avl' ).addClass( 'hide' );
            $( '.js-status-soldout' ).removeClass( 'hide' );
            // Sold out, disable the submit button and change text 
          }
        } else {
          if (form) form.dataset.selectedVariant = ""

          // The variant doesn't exist, disable submit button
          $( '.js-status-avl' ).addClass( 'hide' );
          $( '.js-status-soldout' ).removeClass( 'hide' );
        }
      },

      updateVariantButtonAvailability: async function ( e ) {
        const form = document.querySelector(this.selectors.formContainer)
        if (!form || form.querySelector(".variant-wrapper--dropdown")) {
          return;
        }
        const variant = e.variant;
        const inputs = [...this.$variantSelectors];
        const checkedInputs = inputs.filter(el => el.checked );
        const optionValues = checkedInputs.map( input => input.dataset.optionValueId );
        const url = new URL(window.location.href);
        url.searchParams.set('option_values', optionValues.join(','));
        url.searchParams.set('section_id', "variant-availability-helper");
        const res = await fetch(url.toString());
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const el = doc.querySelector('#VariantAvailabilityData');
        const data = el ? JSON.parse(el.textContent) : null;
        for (const el of inputs) {
          if (!data) el.classList.remove('disabled');
          const valueId = Number(el.dataset.optionValueId);
          const isAvailable = data[valueId];
          el.classList.toggle('disabled', !isAvailable);
        }
      },

      updatePrice: function ( evt ) {
        var variant = evt.variant;



        if ( variant ) {
          // Regular price

          $( this.selectors.price ).html( theme.Currency.formatMoney( variant.price, theme.settings.moneyFormat ) ).show();
          $( '.js-price-default' ).attr( 'data-price', theme.Currency.formatMoney( variant.price ) )

          $( this.selectors.comparePrice ).html( '' );

          // Sale price, if necessary
          if ( variant.compare_at_price > variant.price ) {

            $( this.selectors.comparePrice ).html( theme.Currency.formatMoney( variant.compare_at_price, theme.settings.moneyFormat ) );
            // $(this.selectors.priceWrapper).removeClass('hide');
            // $(this.selectors.price).addClass(classes.onSale);
            // $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
            // $(this.selectors.priceA11y).attr('aria-hidden', 'false');

            var savings = variant.compare_at_price - variant.price;

            if ( theme.settings.saveType == 'percent' ) {
              savings = Math.round( ( ( savings ) * 100 ) / variant.compare_at_price ) + '%';
            } else {
              savings = theme.Currency.formatMoney( savings, theme.settings.moneyFormat );
            }

            $( this.selectors.savePrice )
              .removeClass( 'hide' )
              .html( theme.strings.savePrice.replace( '[saved_amount]', savings ) );
          } else {
            $( this.selectors.priceWrapper ).addClass( 'hide' );
            $( this.selectors.price ).removeClass( classes.onSale );
            $( this.selectors.comparePriceA11y ).attr( 'aria-hidden', 'true' );
            $( this.selectors.priceA11y ).attr( 'aria-hidden', 'true' );
            $( this.selectors.savePrice ).addClass( 'hide' )
          }

          if ( theme.settings.currenciesEnabled ) {
            theme.currencySwitcher.ajaxrefresh();
          }
        }
      },

      updateUnitPrice: function ( evt ) {
        var variant = evt.variant;

        if ( variant && variant.unit_price ) {
          $( this.selectors.unitPrice ).html( theme.Currency.formatMoney( variant.unit_price, theme.settings.moneyFormat ) );
          $( this.selectors.unitPriceBaseUnit ).text( theme.Currency.getBaseUnit( variant ) );
          $( this.selectors.unitWrapper ).removeClass( 'hide' ).removeClass( classes.visuallyHide );
        } else {
          $( this.selectors.unitWrapper ).addClass( classes.visuallyHide );
        }
      },

      updateSku: function ( evt ) {
        var variant = evt.variant;
        var newSku = '';

        if ( variant ) {
          if ( variant.sku ) {
            newSku = variant.sku;
          }

          $( this.selectors.sku ).html( newSku );
        }
      },

      updateVariantTitle: function ( evt ) {

        $.each( evt.variant.options, function ( index, value ) {
          $( '.group--index-' + index + ' .group__titleValue' ).html( value )
        } );

        var variant = evt.variant;
        var newVariantTitle = '';

        if ( variant ) {
          if ( variant.title ) {
            newVariantTitle = variant.title;
          }

          $( this.selectors.variantTitle ).html( newVariantTitle );
        }
      },

      updateInventory: function ( evt ) {
        var variant = evt.variant;

        // If we don't track variant inventory, hide stock
        if ( !variant || !variant.inventory_management ) {
          this.toggleInventoryQuantity( false );
          this.toggleIncomingInventory( false );
          return;
        }

        if ( variant.inventory_management === 'shopify' && window.inventories && window.inventories[ this.sectionId ] ) {
          variantInventoryObject = window.inventories[ this.sectionId ][ variant.id ];
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;

          if ( quantity <= 0 || quantity > theme.settings.inventoryThreshold ) {
            showInventory = false;
          }

          this.toggleInventoryQuantity( showInventory, quantity );

          if ( !showInventory && variantInventoryObject.incoming ) {
            showIncomingInventory = true;
          }

          this.toggleIncomingInventory( showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date );
        }
      },

      toggleInventoryQuantity: function ( show, qty ) {
        if ( !this.settings.inventory ) {
          show = false;
        }

        if ( show ) {
          $( this.selectors.inventory )
            .removeClass( 'hide' )
            .text( theme.strings.stockLabel.replace( '[count]', qty ) );
        } else {
          $( this.selectors.inventory ).addClass( 'hide' );
        }
      },

      toggleIncomingInventory: function ( show, available, date ) {
        if ( !this.settings.incomingInventory ) {
          show = false;
        }

        if ( show ) {
          var string = available ?
            theme.strings.willNotShipUntil.replace( '[date]', date ) :
            theme.strings.willBeInStockAfter.replace( '[date]', date );

          if ( !date ) {
            string = theme.strings.waitingForStock;
          }

          $( this.selectors.incomingInventory )
            .removeClass( 'hide' )
            .text( string );
        } else {
          $( this.selectors.incomingInventory ).addClass( 'hide' );
        }
      },
      setProductType: function ( variantTitle ) {
        $( '#LensCategory-' + this.sectionId + '-gallery' ).attr( 'data-variant-title', variantTitle );
      },
      updateVariantImage: function ( evt ) {

        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl( variant.featured_image.src, this.settings.imageSize );

        var $newImage = $( '.product__thumb[data-id="' + variant.featured_image.id + '"]' );
        var imageIndex = this._slideIndex( $newImage.closest( '.product__thumb-item' ) );

        if ( $( '#LensCategory-' + this.sectionId + '-gallery' ).length ) {
          this.setProductType( $( '.js-main-product-selectbox option:selected' ).attr( 'data-variant-title' ) )
        }


        $( '.group--bundle .group__value' ).prop( 'checked', false );
        $( '.group--orig .group__value' ).prop( 'checked', true ).trigger( 'change' );



        // No image, bail
        if ( typeof imageIndex === 'undefined' ) {
          return;
        }

        // this.$mainSlider.slick('slickGoTo', imageIndex);
      },

      // Image/thumbnail toggling
      initImageSwitch: function () {
        if ( !$( this.selectors.photoThumbs ).length ) {
          return;
        }

        var self = this;

        $( this.selectors.photoThumbs ).on( 'click', function ( evt ) {
          evt.preventDefault();
        } );
      },





      createImageCarousels: function () {
        if ( !this.$thumbSlider.length || $( this.selectors.photoThumbs ).length < 2 ) {
          this.$mainSlider[ 0 ].classList.remove( 'slider-loading' )
          // Single product image. Init video if it exists
          var $video = $( this.selectors.productImageMain ).find( selectors.productVideo );
          if ( $video.length ) {
            this.initVideo( $video );
          }
          return;
        }

        this.settings.hasMultipleImages = true;

        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find( '.starting-slide' );
        var startIndex = this._slideIndex( $activeSlide );

        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off( 'init' );
        this.$mainSlider.off( 'beforeChange' );
        this.$mainSlider.on( 'init', this.mainSlideInit.bind( this ) );
        this.$mainSlider.on( 'beforeChange', this.beforeSlideChange.bind( this ) );
        this.$thumbSlider.on( 'init', this.thumbSlideInit.bind( this ) );

        // Default (mobile) slider settings
        this.mainSliderArgs = {
          infinite: true,
          arrows: false,
          dots: true,

          adaptiveHeight: true,
          initialSlide: startIndex
        };

        this.thumbSliderArgs = {
          initialSlide: startIndex
        };

        // Init sliders normally
        var sliderArgs = this.setSliderArgs();
        this.initSliders( sliderArgs );

        // Re-init slider when a breakpoint is hit
        $( 'body' ).on( 'matchSmall matchLarge', function () {
          this.$mainSlider.slick( 'slickGoTo', 0 ).slick( 'slickUnfilter' )
          this.$thumbSlider.slick( 'slickGoTo', 0 ).slick( 'slickUnfilter' )
          var sliderArgs = this.setSliderArgs();
          this.initSliders( sliderArgs );
        }.bind( this ) );

      },

      initSliders: function ( args ) {
        this.destroyImageCarousels();
        this.$mainSlider.slick( args.main );
        this.$thumbSlider.slick( args.thumbs );
        // const currentVariantObject = JSON.parse((document.getElementById(this.selectors.currentVariantJson) || document.getElementById(this.selectors.initialVariantJson)).innerHTML)
        const currentVariantObject = this.variants.currentVariant
        const currVariantIndex = this.variantsObject.findIndex( item => item.id === currentVariantObject.id )
        const filterClass = `.lifestyle-img,.variant-img-${ currVariantIndex }`
        this.updateSliderFilters( filterClass )

        this.settings.slickMainInitialized = true;

      },

      updateSliderFilters: function ( filterClass ) {
        try {
          
          this.$mainSlider.slick( 'slickGoTo', 0 ).slick( 'slickUnfilter' ).slick( 'slickFilter', filterClass ).slick( 'refresh' )
  
          this.$thumbSlider.slick( 'slickGoTo', 0 ).slick( 'slickUnfilter' )
          const count = this.$thumbSlider[ 0 ].querySelectorAll( filterClass ).length
          this.$thumbSlider.slick( 'slickSetOption', 'slidesToShow', count || 1 ).slick( 'slickFilter', filterClass ).slick( 'refresh' )
        } catch (error) {
          console.error(error)
        }

      },

      setSliderArgs: function () {
        var args = {};

        var thumbnailsVertical = this.settings.thumbVertical = this.$thumbSlider.data( 'position' ) === 'beside' ? true : false;
        var thumbArrows = this.settings.thumbArrows = this.$thumbSlider.data( 'arrows' );

        var slidesToShow = thumbnailsVertical && thumbArrows ? 1 :
          ( thumbnailsVertical ? 3 : 5 );

        if ( theme.config.bpSmall ) {
          args.main = this.mainSliderArgs;
          args.thumbs = this.thumbSliderArgs;
        } else {
          args.main = $.extend( {}, this.mainSliderArgs, {
            asNavFor: this.selectors.thumbSlider,
            adaptiveHeight: thumbnailsVertical ? false : true,
            dots: false,
            // slidesToShow: 5,
            infinite: false,
            fade: true,
            draggable: false
          } );
          args.thumbs = $.extend( {}, this.thumbSliderArgs, {
            asNavFor: this.selectors.mainSlider,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: thumbArrows,
            dots: false,
            vertical: thumbnailsVertical,
            verticalSwiping: thumbnailsVertical,
            focusOnSelect: true,
            infinite: false,
            customHeightMatching: thumbArrows ? false : thumbnailsVertical,
            customSlideAdvancement: true
          } );
        }

        return args;
      },

      destroyImageCarousels: function () {
        if ( this.$mainSlider && this.settings.slickMainInitialized ) {
          this.$mainSlider.slick( 'unslick' );
          this.settings.slickMainInitialized = false;
        }

        if ( this.$thumbSlider && this.settings.slickThumbInitialized ) {
          this.$thumbSlider.slick( 'unslick' );
          this.settings.slickThumbInitialized = false;
        }

        this.settings.slickMainInitialized = false;
        this.settings.slickThumbInitialized = false;
      },

      mainSlideInit: function ( event, slick ) {

        var $slider = slick.$slider;
        var $currentSlide = $slider.find( selectors.currentSlide );
        var $video = $currentSlide.find( selectors.productVideo );

        if ( !$video.length ) {
          return;
        }

        this.initVideo( $video );

      },

      thumbSlideInit: function ( event, slick ) {

        this.settings.slickThumbInitialized = true;

        // Check if we need to hide the arrows
        if ( this.settings.thumbArrows ) {
          this.$thumbSlider.on( 'setPosition', this.thumbSlideArrowVisibility.bind( this ) );
        }

      },

      thumbSlideArrowVisibility: function ( event, slick ) {

        var $slider = slick.$slider;
        var $arrows = $slider.find( '.slick-arrow' );
        var showArrows = false;

        if ( this.settings.thumbVertical ) {
          var $trackHeight = $slider.find( '.slick-track' ).height();
          if ( $trackHeight >= $slider.height() ) {
            showArrows = true;
          }
        } else {
          var $trackWidth = $slider.find( '.slick-track' ).width();
          if ( $trackWidth >= $slider.width() ) {
            showArrows = true;
          }
        }

        if ( showArrows ) {
          $arrows.removeClass( 'hide' );
        } else {
          $arrows.addClass( 'hide' );
        }

      },

      initVideo: function ( $video ) {
        /*
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');
  
        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }
  
        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }
  
        if (videoType === 'vimeo') {
          if (vimeoReady) {
            this.playOrShowVimeo(divId);
          } else {
            $('body').on('vimeoReady' + this.settings.namespace, function() {
              this.playOrShowVimeo(divId);
            }.bind(this))
          }
        }
  
        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
        */
      },

      beforeSlideChange: function ( event, slick, currentSlide, nextSlide ) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find( selectors.currentSlide );
        var $prevVideo = $currentSlide.find( '.product__video' );
        var $nextSlide = $slider.find( '.slick-slide[data-slick-index="' + nextSlide + '"]' );
        var $nextVideo = $nextSlide.find( '.product__video' );

        // Pause any existing slide video
        if ( currentSlide !== nextSlide && $prevVideo.length ) {
          var prevVideoType = this.getVideoType( $prevVideo );
          var prevVideoId = this.getVideoId( $prevVideo );

          if ( prevVideoId ) {
            this.stopVideo( prevVideoId, prevVideoType );
          }
        }

        // Prep next slide video
        if ( $nextVideo.length ) {
          var nextVideoType = this.getVideoType( $nextVideo );
          var nextVideoId = this.getVideoId( $nextVideo );

          // Prep Vimeo with a backup in case the API isn't ready
          if ( nextVideoId && nextVideoType === 'vimeo' ) {
            if ( vimeoReady ) {
              if ( videos[ nextVideoId ] && videos[ nextVideoId ].style === 'muted' ) {
                this.autoplayVimeoVideo( nextVideoId );
              }
            } else {
              $( 'body' ).on( 'vimeoReady' + this.settings.namespace, function () {
                if ( videos[ nextVideoId ] && videos[ nextVideoId ].style === 'muted' ) {
                  this.autoplayVimeoVideo( nextVideoId );
                }
              }.bind( this ) )
            }
          }

          // Prep YouTube with a backup in case API isn't ready
          if ( nextVideoId && nextVideoType === 'youtube' ) {
            if ( youtubeReady ) {
              if ( videos[ nextVideoId ] && videos[ nextVideoId ].style === 'muted' ) {
                this.requestToPlayYoutubeVideo( nextVideoId, true );
              }
            } else {
              $( 'body' ).on( 'youTubeReady' + this.settings.namespace, function () {
                if ( videos[ nextVideoId ] && videos[ nextVideoId ].style === 'muted' ) {
                  this.requestToPlayYoutubeVideo( nextVideoId, true );
                }
              }.bind( this ) )
            }
          }

          // Autoplay muted MP4 videos
          if ( nextVideoId && videos[ nextVideoId ] && videos[ nextVideoId ].style === 'muted' ) {
            if ( nextVideoType === 'mp4' ) {
              this.playMp4Video( nextVideoId );
            }
          }

          // Set unmuted videos to loaded state
          if ( nextVideoId && videos[ nextVideoId ] && videos[ nextVideoId ].style != 'muted' ) {
            setParentAsLoaded( $( '#' + nextVideoId ) );
          }
        }

      },

      resizeSlides: function () {
        if ( !this.settings.hasMultipleImages ) {
          return;
        }

        $( window ).trigger( 'resize.slick' );
        setTimeout( function () {
          if ( this.$mainSlider && this.settings.slickMainInitialized ) {
            this.$mainSlider.slick( 'setPosition' );
          }
          if ( this.$thumbSlider && this.settings.slickThumbInitialized ) {
            this.$thumbSlider.slick( 'setPosition' );
          }
        }.bind( this ), 500 ); // same timing as modal open transition

      },

      _slideIndex: function ( $el ) {
        return $el.data( 'index' );
      },

      initQtySelector: function () {
        this.$container.find( '.js-qty__wrapper' ).each( function () {
          new theme.QtySelector( $( this ), {
            namespace: '.product'
          } );
        } );
      },

      initAjaxProductForm: function () {
        if ( theme.settings.cartType === 'drawer' ) {
          new theme.AjaxProduct( $( this.selectors.formContainer ) );
        }

      },

      openModalProduct: function () {
        if ( !this.settings.modalInit ) {
          var $formHolder = $( this.selectors.modalFormHolder );
          var url = $formHolder.data( 'url' );
          var template = $formHolder.data( 'template' );

          // If no alt template, use stripped down ajax version
          if ( !template ) {
            url = url + '?view=ajax';
          }

          $formHolder.load( url + ' #AddToCartForm-' + this.sectionId, function () {
            $formHolder.addClass( 'is-active' );
            this.formSetup();
            if ( Shopify.PaymentButton ) {
              Shopify.PaymentButton.init();
            }
          }.bind( this ) );

          this.productSetup();
          this.loadModalContent();
          this.createImageCarousels();
          this.settings.modalInit = true;
        }

        this.resizeSlides();

        // Add product id to recently viewed array
        this.addIdToRecentlyViewed();
      },




      onUnload: function () {
        this.$container.off( this.settings.namespace );
        $( 'body' ).off( this.settings.namespace );
        this.destroyImageCarousels();
      }
    } );

    return Product;
  } )();




  // Medium breakpoint is also set in theme.scss.liquid and inline throughout some templates.
  // Do not change values unless you know what you're doing.
  theme.bp = {};
  // theme.bp.smallUp = 769;
  theme.bp.smallUp = 991;
  theme.bp.small = theme.bp.smallUp - 1;

  theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    hasLocalStorage: true,
    mediaQuerySmall: 'screen and (max-width: ' + theme.bp.small + 'px)',
    mediaQuerySmallUp: 'screen and (min-width: ' + theme.bp.smallUp + 'px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: ( 'ontouchstart' in window ) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    isIpad: /ipad/.test( window.navigator.userAgent.toLowerCase() ) || ( window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1 ),
    stickyHeader: false,
    recentlyViewed: []
  };

  if ( theme.config.isIpad ) {
    document.documentElement.className += ' js-ipad';
  }

  theme.recentlyViewed = {
    recent: {}, // will store handle+url of recent products
    productInfo: {} // will store product data to reduce API calls
  };

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    $( 'body' ).trigger( 'youTubeReady' );
  }

  window.loadYouTube = function () {
    if ( theme.config.youtubeReady ) {
      return;
    }

    var tag = document.createElement( 'script' );
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
    firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );
  }

  window.loadVimeo = function () {
    if ( theme.config.vimeoLoading ) {
      return;
    }

    if ( !theme.config.vimeoReady ) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement( 'script' );
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
      firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

      // Because there's no way to check for the Vimeo API being loaded
      // asynchronously, we use this terrible timeout to wait for it being ready
      checkIfVimeoIsReady()
        .then( function () {
          theme.config.vimeoReady = true;
          theme.config.vimeoLoading = false;
          $( 'body' ).trigger( 'vimeoReady' );
        } )
        .fail( function () {
          // No vimeo API to talk to
        } );
    }
  }

  function checkIfVimeoIsReady () {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval( function () {
      if ( !Vimeo ) {
        return;
      }

      clearInterval( wait );
      clearTimeout( timeout );
      deferred.resolve();
    }, 500 );

    timeout = setTimeout( function () {
      clearInterval( wait );
      deferred.reject();
    }, 4000 ); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  theme.init = function () {
    theme.setGlobals();


    $( document.documentElement ).on( 'keyup.tab', function ( evt ) {
      if ( evt.keyCode === 9 ) {
        $( document.documentElement ).addClass( 'tab-outline' );
        $( document.documentElement ).off( 'keyup.tab' );
      }
    } );

  };

  theme.initSecondary = function () {
    /*
    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }
    */
    //theme.collectionTemplate.init();
    theme.customerTemplates.init();

  };



  theme.setGlobals = function () {
    theme.config.hasSessionStorage = theme.isStorageSupported( 'session' );
    theme.config.hasLocalStorage = theme.isStorageSupported( 'local' );

    if ( theme.config.hasLocalStorage ) {
      theme.recentlyViewed.localStorage = window.localStorage.getItem( 'theme-recent' );

      if ( theme.recentlyViewed.localStorage ) {
        theme.recentlyViewed.recent = JSON.parse( theme.recentlyViewed.localStorage );
      }
    }

    theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage[ 'recent-products' ] ? JSON.parse( sessionStorage[ 'recent-products' ] ) : {};

    if ( theme.config.isTouch ) {
      $( 'body' ).addClass( 'supports-touch' );
    }

    enquire.register( theme.config.mediaQuerySmall, {
      match: function () {
        theme.config.bpSmall = true;
        $( 'body' ).trigger( 'matchSmall' );
      },
      unmatch: function () {
        theme.config.bpSmall = false;
        $( 'body' ).trigger( 'unmatchSmall' );
      }
    } );

    enquire.register( theme.config.mediaQuerySmallUp, {
      match: function () {
        $( 'body' ).trigger( 'matchLarge' );
      },
      unmatch: function () {
        $( 'body' ).trigger( 'unmatchLarge' );
      }
    } );
  };

  theme.loadImageSection = function ( $container ) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded () {
      $container.removeClass( 'loading loading--delayed' ).addClass( 'loaded' );
    }

    function checkForLazyloadedImage () {
      return $container.find( '.lazyloaded' ).length;
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if ( $container.find( 'svg' ).length ) {
      setAsLoaded();
      return;
    };

    if ( checkForLazyloadedImage() > 0 ) {
      setAsLoaded();
      return;
    }

    var interval = setInterval( function () {
      if ( checkForLazyloadedImage() > 0 ) {
        clearInterval( interval );
        setAsLoaded();
      }
    }, 80 );
  };

  theme.isStorageSupported = function ( type ) {
    // Return false if we are in an iframe without access to sessionStorage
    if ( window.self !== window.top ) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if ( type === 'session' ) {
      storage = window.sessionStorage;
    }
    if ( type === 'local' ) {
      storage = window.localStorage;
    }

    try {
      storage.setItem( testKey, '1' );
      storage.removeItem( testKey );
      return true;
    } catch ( error ) {
      return false;
    }
  };

  theme.isElementVisible = function ( $el, threshold ) {
    var rect = $el[ 0 ].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;

    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= ( windowHeight + threshold ) &&
      rect.left <= ( window.innerWidth || document.documentElement.clientWidth )
    );
  };

  theme.reinitSection = function ( section ) {
    for ( var i = 0; i < sections.instances.length; i++ ) {
      var instance = sections.instances[ i ];
      if ( instance[ 'type' ] === section ) {
        if ( typeof instance.forceReload === 'function' ) {
          instance.forceReload();
        }
      }
    }
  };

  theme.reinitProductGridItem = function ( $scope ) {


    // Refresh currency
    if ( theme.settings.currenciesEnabled ) {
      theme.currencySwitcher.ajaxrefresh();
    }

    // Reload quick shop buttons
    //theme.initQuickShop(true);

    // Refresh reviews app
    /*
    if (window.SPR) {
      SPR.initDomEls();SPR.loadBadges();
    }
    */

    // Re-register product templates in quick view modals.
    // Will not double-register.
    sections.register( 'product-template', theme.Product, $scope );

    // Re-hook up collapsible box triggers
    // theme.collapsibles.init();
  };

  window.onpageshow = function ( evt ) {
    // Removes unload class when returning to page via history
    if ( evt.persisted ) {
      $( 'body' ).removeClass( 'unloading' );
    }
  };

  $( document ).ready( function () {
    theme.init();

    window.sections = new theme.Sections();
    sections.register( 'header-section', theme.HeaderSection );
    sections.register( 'slideshow-section', theme.SlideshowSection );
    sections.register( 'video-section', theme.VideoSection );
    sections.register( 'background-image', theme.BackgroundImage );
    sections.register( 'recently-viewed', theme.RecentlyViewed );
    sections.register( 'product', theme.Product );
    sections.register( 'product-recommendations', theme.Recommendations );
    sections.register( 'product-template', theme.Product );
    sections.register( 'collection-header', theme.CollectionHeader );
    sections.register( 'collection-sidebar', theme.CollectionSidebar );
    sections.register( 'collection-template', theme.Collection );
    sections.register( 'featured-content-section', theme.FeaturedContentSection );
    sections.register( 'testimonials', theme.Testimonials );
    sections.register( 'instagram', theme.Instagram );
    sections.register( 'newsletter-popup', theme.NewsletterPopup );
    sections.register( 'map', theme.Maps );
    sections.register( 'blog', theme.Blog );
    // sections.register('photoswipe', theme.Photoswipe);

    theme.initSecondary();
  } );
} )( theme.jQuery );

/*
document.addEventListener('DOMContentLoaded', function() {
  $(".grid-product__colors").slick({
    slidesToShow:4,
    swipeToSlide:true,
    autoplay: true,
    autoplaySpeed: 2000
  });
});
*/
